<script lang="ts">
    /**
     * JadeyeSubNav - JadEye 제품 페이지 전용 서브 네비게이션
     *
     * 공통 앱바(LandingNav)는 회사 메뉴로 통일됐으므로,
     * JadEye 내부 섹션 점프(기능소개/가격)와 앱 다운로드는 이 서브네비가 담당.
     * sticky 로 공통 앱바 아래에 고정된다.
     */
    const subLinks = [
        { href: '#features', label: '기능소개' },
        { href: '/guide', label: '가이드' },
        { href: 'https://cafe.naver.com/jadeye', label: '커뮤니티', external: true },
    ];

    function handleSubClick(e: MouseEvent, href: string) {
        // 해시 앵커만 스크롤 점프. /guide(클라 라우팅)·외부 링크는 기본 동작 유지.
        if (href.startsWith('#')) {
            e.preventDefault();
            const el = document.querySelector(href);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
</script>

<div class="jadeye-subnav">
    <div class="subnav-inner">
        <span class="subnav-brand">JadEye</span>

        <div class="subnav-right">
            <nav class="subnav-links" aria-label="JadEye 섹션">
                {#each subLinks as l}
                    <a
                        href={l.href}
                        class="subnav-link"
                        target={l.external ? '_blank' : undefined}
                        rel={l.external ? 'noopener noreferrer' : undefined}
                        onclick={(e) => handleSubClick(e, l.href)}
                    >{l.label}</a>
                {/each}
            </nav>

            <div class="subnav-badges">
                <a
                    href="https://play.google.com/store/apps/details?id=com.bjf.jadeye"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="subnav-badge-link"
                    aria-label="Google Play에서 다운로드 (새 창에서 열림)"
                >
                    <img src="/images/google-play-badge-ko.svg" alt="Google Play에서 다운로드" class="subnav-badge" />
                </a>
                <a
                    href="https://apps.apple.com/kr/app/%EC%A0%9C%EC%9D%B4%EB%93%9C%EC%95%84%EC%9D%B4/id6759511149"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="subnav-badge-link"
                    aria-label="App Store에서 다운로드 (새 창에서 열림)"
                >
                    <img src="/images/app-store-badge-ko.svg" alt="App Store에서 다운로드" class="subnav-badge appstore" />
                </a>
            </div>
        </div>
    </div>
</div>

<style>
    .jadeye-subnav {
        position: sticky;
        /* 공통 앱바(LandingNav) 높이만큼 아래에 고정 */
        top: 4.25rem;
        z-index: 90;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(16px);
        border-bottom: 1px solid rgba(30, 92, 58, 0.08);
        box-shadow: 0 1px 8px rgba(0, 0, 0, 0.03);
    }

    .subnav-inner {
        max-width: 72rem;
        margin: 0 auto;
        padding: 0.55rem 1.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
    }

    .subnav-brand {
        font-size: 1.05rem;
        font-weight: 700;
        letter-spacing: -0.02em;
        color: var(--landing-primary, #1e5c3a);
        flex-shrink: 0;
    }

    .subnav-right {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .subnav-links {
        display: flex;
        align-items: center;
        gap: 0.25rem;
    }

    .subnav-link {
        padding: 0.4rem 0.85rem;
        border-radius: 8px;
        text-decoration: none;
        font-size: 0.9rem;
        font-weight: 500;
        color: var(--landing-text-sub, #666666);
        transition: all 0.2s;
        white-space: nowrap;
    }

    .subnav-link:hover {
        color: var(--landing-primary, #1e5c3a);
        background: rgba(30, 92, 58, 0.06);
    }

    .subnav-badges {
        display: flex;
        align-items: center;
        gap: 0.4rem;
    }

    .subnav-badge-link {
        display: inline-flex;
        align-items: center;
        transition: opacity 0.2s, transform 0.2s;
    }

    .subnav-badge-link:hover {
        opacity: 0.85;
        transform: translateY(-1px);
    }

    .subnav-badge {
        height: 1.85rem;
        object-fit: contain;
        display: block;
    }

    /* 모바일: 다운로드 배지는 숨기고 섹션 링크만 (공간 절약) */
    @media (max-width: 640px) {
        .subnav-badges {
            display: none;
        }

        .subnav-inner {
            padding: 0.5rem 1.25rem;
        }
    }

    @media (min-width: 1024px) {
        .jadeye-subnav {
            top: 5rem;
        }

        .subnav-inner {
            padding: 0.6rem 3rem;
        }
    }
</style>
